
import React from 'react'


// function to describe in words the repeating nature of event
const ReadableRepeat = ({ repeatType, eventType, startDate, endDate, repeatData, weekRepeatFreq, noEndDate }) => {
    if (!repeatType || !eventType || !startDate || !endDate || !repeatData?.length) return ''
    const repeatString = () => {
        if (repeatType === 'day') {
            if (repeatData === "2x" || repeatData === "3x") {
                return `${repeatData} per day`
            }
            else if (parseInt(repeatData) === 1) {
                return 'every day'
            } else {
                return `every ${repeatData} days`
            }
        } else {
            return `${repeatData.join(', ')} every ${(weekRepeatFreq == 1 || weekRepeatFreq === "") ? 'week' : `${weekRepeatFreq} weeks`}`
        }
    }
    const dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
    return (
        <small className="mt-2 mb-3 d-block text-center">
            This event will repeat starting
            <span className="mx-1 text-primary">{startDate.toLocaleDateString(undefined, dateOptions)}</span>
            and repeat
            <span className="mx-1 text-primary">{repeatString()}</span>
            {!noEndDate && "until"}
            {!noEndDate && <span className="mx-1 text-primary">{endDate.toLocaleDateString(undefined, dateOptions)}</span>}
        </small>
    )
}

export default ReadableRepeat